import { useMutation } from '@tanstack/react-query';

import postUserAvalaibility from 'Api/user/postUserAvailability';

import postUserAvailabilityPayload from './model/request/postUserAvailabilityPayload';

const usePostUserAvailability = (setError) => {
  return useMutation({
    mutationFn: async (data) => {
      const payload = postUserAvailabilityPayload(data);

      const response = await postUserAvalaibility({ payload });

      return response;
    },
    onError: (error) => {
      const errorFields = error?.response?.data?.errorFields;

      if (errorFields?.name) setError('name', { type: 'custom', message: errorFields?.name?.message || '' });
      if (errorFields?.email) setError('email', { type: 'custom', message: errorFields?.email?.message || '' });
    },
  });
};

export default usePostUserAvailability;
